<template>
    <div>
        <p>选择需要分裂的field，获取唯一值，作为排，如果不选将不进行分裂</p>
        <el-checkbox-group v-model="splittarget" :max="1" @change="getsplituniques">
            <el-checkbox v-if="(x.type != 'addon') && (x.type != 'numberrange')" v-for="x in fields" :label="x.name"
                :key="x.name">{{
                    x.title
                }}</el-checkbox>
        </el-checkbox-group>

        <el-input type="textarea" autosize placeholder="Please input" v-model="splituniques" clearable>
        </el-input>


        <p>选择需固定的fields,作为列</p>
        <el-checkbox-group v-model="splitfixed">
            <el-checkbox v-if="(x.type != 'addon') && (x.type != 'numberrange')" @change="splitfixedchanged(x)"
                v-for="x in fields" :label="x.name" :key="x.name">{{
                    x.title
                }}</el-checkbox>
        </el-checkbox-group>

        <el-dialog width="80%" title="选择时间模式" :visible.sync="showtimemodel" append-to-body>

            <el-radio-group v-model="timemodel">
                <el-radio-button label="year"></el-radio-button>
                <el-radio-button label="month"></el-radio-button>
                <el-radio-button label="day"></el-radio-button>
            </el-radio-group>

        </el-dialog>


        <p>选择求和项</p>
        <el-checkbox-group v-model="sumitem">
            <el-checkbox v-if="x.type == 'numberrange'" v-for="x in fields" :label="x.name" :key="x.name">{{
                x.title
                }}</el-checkbox>
        </el-checkbox-group>

        <p>输入theeval</p>

        <el-input type="textarea" placeholder="请输入内容" v-model="theevalforsplit">
        </el-input>

        <el-dialog width="80%" title="选择参数" :visible.sync="showparamsplit" append-to-body @close="resetsplit">
            <el-input type="textarea" autosize placeholder="Please input" v-model="paramsplit" clearable>
            </el-input>
            <el-button @click="generateurl">生成链接</el-button>
        </el-dialog>

        <el-button :disabled="!splitready" @click="splitfield">确认</el-button>
        <el-button :disabled="!splitready" @click="generateparams">获取参数</el-button>
    </div>
</template>

<script>
import { getparamsfromstore, tomakeurl } from "@/axios/objparamobj"
export default {
    data() {
        return {
            showparamsplit: false,
            showtimemodel: false,
            timemodel: "day",
            splitdatefield: "",
            paramsplit: "",
            splittarget: [],
            splituniques: "",
            splitfixed: [],
            sumitem: [],
            theevalforsplit:""
        }
    },

    computed: {
        fields() {
            return this.$store.state.currentheader;
        },
        splitready() {
            return (
                !(this.splitfixed.length < 1 || this.sumitem.length < 1)
            )
        },
    },

    methods: {
        splitfixedchanged(field) {

            if (field.type == "daterange") {
                this.showtimemodel = true
                this.splitdatefield = field.name
            }
        },

        getsplituniques() {
            this.$store.commit("setsplittarget", this.splittarget[0]);
            let params = getparamsfromstore("getsplituniques")
            this.$axios.post(url + "getsplituniques", params)
                .then(res => {
                    this.splituniques = JSON.stringify(res.data, null, 4)
                })
        },

        splitfieldconfig() {
            let store = this.$store;
            let querycurrent = getparamsfromstore(store.state.searchmodel)
            let urlcurrent = tomakeurl(querycurrent, store.state.searchmodel)
            store.commit("seturlbeforesplit", urlcurrent)
            store.commit("setsearchmodelthattime", store.state.searchmodel);
            store.commit("setsearchmodel", "splitfield");
            store.commit("setsplittarget", this.splittarget[0]);
            if (this.splittarget.length > 0) {
                store.commit("setsplituniques", JSON.parse(this.splituniques));
            }
            store.commit("setsplitfixed", this.splitfixed.reverse());
            store.commit("setsumitem", this.sumitem);
            store.commit("settheevalforsplit", this.theevalforsplit);
            store.commit("setsplittimemodel", { field: this.splitdatefield, timemodel: this.timemodel });
        },
        resetsplit() {

            this.splittarget = []
            this.splituniques = ""
            this.splitfixed = []
            this.sumitem = []
            let store = this.$store;
            store.commit("seturlbeforesplit", "")
            store.commit("setsearchmodelthattime", "");
            store.commit("setsearchmodel", "generalsearch");
            store.commit("setsplittarget", "");
            store.commit("setsplituniques", []);
            store.commit("setsplitfixed", []);
            store.commit("setsumitem", []);
        },

        splitfield() {
            this.splitfielddialog = false;
            this.splitfieldconfig();
            this.$axios.fetchdata();
        },

        generateparams() {
            this.splitfieldconfig();
            // console.log(this.$store.state.splittimemodel)
            this.paramsplit = JSON.stringify(getparamsfromstore("splitfield"), null, 4);
            this.showparamsplit = true
            // this.$axios.generateurl(query)
        },

        generateurl() {
            let query = JSON.parse(this.paramsplit)
            this.$axios.generateurl(query)
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/tosplitfield.vue